import { OnAnimationFrame } from "../../animation/OnAnimationFrame";
import { ClassFlag } from "../../dom-tools/ClassFlag";
import { ElementType } from "../../dom-tools/ElementType";
import { OnResize } from "../../dom-tools/EventListeners";
import { LinkedGraphicalElement } from "../graphical/LinkedGraphicalElement";
import { LinkedGraphicalElementList } from "../graphical/LinkedGraphicalElementList";
import { UIComponent } from "./UIComponent";

export class AutoResizeView extends UIComponent
{
  static readonly elementType = new ElementType( "ui--auto--resize" );

  static readonly contentFlag = new ClassFlag( "ui--content" );
  
  readonly content = new LinkedGraphicalElement( this, AutoResizeView.contentFlag );  
  #onAnimationFrame = new OnAnimationFrame();
  
  #width:number = null;
  #height:number = null;

  constructor( element?:Element )
  {
    super();

    
    this._setElement( element || AutoResizeView.elementType.create() );
    
    this.#onAnimationFrame.addListener(
      ()=>
      {
        let rect = this.element.getBoundingClientRect();

        //console.log( "CHECKING BOUNDS:", rect, this.#width, this.#height );
        
        if ( this.#width === rect.width && this.#height === rect.height )
        {
          return;
        }

        this.#width  = rect.width;
        this.#height = rect.height;
        
        console.log( "CHANGED BOUNDS:", rect );

        this._setDimensions();
      }
    );

    this.#onAnimationFrame.run();


    this._setDimensions();
  }

  protected _setDimensions()
  {

    if ( this.content.value )
    {
      this.content.value.dimensions.set( 0, 0, this.#width, this.#height );
    }

  }

  protected _update()
  {
    
  }
  /*
  protected _update()
  {
    super._update();

    

  }*/


}